import createReactComponent from '../createReactComponent';
export default createReactComponent('letter-a', 'LetterA', [["path",{"d":"M14.25 13.667 11.75 7l-2.5 6.667m5 0L15.5 17m-1.25-3.333h-5M8 17l1.25-3.333","key":"svg-0"}]]);